export default __webpack_public_path__ + "static/media/rimani.aa6256da.svg";